import React from "react";

function LinkedIn(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 18 18" fill="currentColor" {...props}>
      <path
        d="M15.2499 2.25101H3.74618C3.20249 2.24487 2.75664 2.68039 2.75 3.22408V14.7757C2.75641 15.3197 3.20223 15.7556 3.74618 15.7499H15.2499C15.7949 15.7567 16.2425 15.3208 16.25 14.7757V3.22325C16.2422 2.67848 15.7946 2.24299 15.2499 2.25009"
        fill="#0A66C2"
      />
      <path
        d="M12.2526 13.7529H14.2529L14.2537 10.219C14.2537 8.48414 13.8799 7.15059 11.8525 7.15059C11.0775 7.12182 10.3494 7.52168 9.95789 8.19117H9.93102V7.31082H8.01075V13.7527H10.011V10.5659C10.011 9.72559 10.1704 8.91171 11.2122 8.91171C12.2393 8.91171 12.2526 9.87332 12.2526 10.6203V13.7529Z"
        fill="white"
      />
      <path
        d="M4.59277 5.26966C4.59289 5.91076 5.11268 6.43038 5.75377 6.43027C6.06163 6.43021 6.35686 6.30786 6.57451 6.09012C6.79216 5.87239 6.9144 5.57711 6.91435 5.26925C6.91423 4.62815 6.39444 4.10853 5.75335 4.10864C5.11227 4.10876 4.59266 4.62856 4.59277 5.26966Z"
        fill="white"
      />
      <path
        d="M4.75155 13.7529H6.75391V7.31082H4.75155V13.7529Z"
        fill="white"
      />
    </svg>
  );
}

const MemoLinkedIn = React.memo(LinkedIn);
export default MemoLinkedIn;
